import validate from "/usr/src/app/content/n3-spas-3fbbf4ef-6700-4f22-ac93-01bf018153fe/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-3fbbf4ef-6700-4f22-ac93-01bf018153fe/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}